// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
// import './assets/css/color.less'
import {download} from './utils/monitor'
Vue.prototype.download = download
Vue.config.productionTip = false
Vue.use(iView)

if (!sessionStorage.token) {
  const hash = location.hash
  const pageStr = hash.split('#/')
  console.log('pageStr', pageStr)
  const name = pageStr.length && pageStr[1] ? pageStr[1].split('?') : []
  console.log('name', name)
  location.assign(`index.html#/login?referPage=${name[0] || ''}`)
}

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  next()
})

router.afterEach((to, from, next) => {
  iView.LoadingBar.finish()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js